<div class="flex items-center flex-col text-center">
  <img alt="provadis-logo" class="provadis-logo mb-3 mt-3" src="/assets/provadis-logo.svg" />
  <h4 class="pb-5 text-primary text-2xl font-bold">Provadis Kleidungs- und Spindverwaltungssystem</h4>
  <div class="font-light pb-10">
    Bitte loggen Sie sich ein, um Zugriff zum Kleidungs- und Spindverwaltungssystem zu erhalten.
  </div>
  <app-main-button size="large" (clickEvent)="login()">Login</app-main-button>
</div>
